"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = exports.Item = void 0;
const react_1 = __importDefault(require("react"));
// https://react-spectrum.adobe.com/react-aria/useTabList.html
const react_aria_1 = require("react-aria");
const react_stately_1 = require("react-stately");
Object.defineProperty(exports, "Item", { enumerable: true, get: function () { return react_stately_1.Item; } });
require("./tablist.scss");
function Tabs(props) {
    var _a;
    const state = (0, react_stately_1.useTabListState)(props);
    const ref = react_1.default.useRef(null);
    const { tabListProps } = (0, react_aria_1.useTabList)(props, state, ref);
    return (react_1.default.createElement("div", { className: `tabs ${props.orientation || ''}` },
        react_1.default.createElement("div", Object.assign({}, tabListProps, { ref: ref }), [...state.collection].map((item) => (react_1.default.createElement(Tab, { key: item.key, item: item, state: state })))),
        react_1.default.createElement(TabPanel, { key: (_a = state.selectedItem) === null || _a === void 0 ? void 0 : _a.key, state: state })));
}
exports.Tabs = Tabs;
function Tab({ item, state }) {
    const { key, rendered } = item;
    const ref = react_1.default.useRef(null);
    const { tabProps } = (0, react_aria_1.useTab)({ key }, state, ref);
    return (react_1.default.createElement("div", Object.assign({}, tabProps, { ref: ref }), rendered));
}
function TabPanel(_a) {
    var _b;
    var { state } = _a, props = __rest(_a, ["state"]);
    const ref = react_1.default.useRef(null);
    const { tabPanelProps } = (0, react_aria_1.useTabPanel)(props, state, ref);
    return (react_1.default.createElement("div", Object.assign({}, tabPanelProps, { ref: ref }), (_b = state.selectedItem) === null || _b === void 0 ? void 0 : _b.props.children));
}
